import { useLocalStorageState } from "@sundae/react-hooks";
import { LOCAL_STORAGE_TASTE_TEST_CONTRIBUTIONS } from "../../constants/localStorage.constants";
import { ITasteTestLocalStorageContributions } from "../../pages/TasteTestDetail/context";

export const usePersistedTasteTestContributionsHistory = () => {
  const [
    persistedContributionsHistory,
    updatePersistedContributionsHistory,
    removePersistedContributionsHistory,
  ] = useLocalStorageState<ITasteTestLocalStorageContributions[]>(
    LOCAL_STORAGE_TASTE_TEST_CONTRIBUTIONS
  );

  return {
    persistedContributionsHistory,
    updatePersistedContributionsHistory,
    removePersistedContributionsHistory,
  };
};
